export const modalMixin = {
  methods: {
    openModal(component, props = {}) {
      this.$root.$emit("openModal", { component, props })
    },
    closeModal() {
      this.$root.$emit("closeModal")
    },
    openDialog(component, props = {}) {
      this.$root.$emit("openDialog", { component, props })
    },
    closeDialog() {
      this.$root.$emit("closeDialog")
    },
  },
}
